import { Component } from '@theme/component';

/**
 * @extends {Component<{ form: HTMLFormElement, email: HTMLInputElement, feedback?: HTMLDivElement }>}
 */
class ContactFormComponent extends Component {
  requiredRefs = ['form', 'email'];
  /** @type {HTMLDivElement | undefined} */
  #focusedFeedback;

  connectedCallback() {
    super.connectedCallback();
    this.#updateFeedback();
    window.addEventListener('hashchange', this.#updateFeedback);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', this.#updateFeedback, { once: true });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('hashchange', this.#updateFeedback);
    window.removeEventListener('load', this.#updateFeedback);
  }

  updatedCallback() {
    super.updatedCallback();
    this.#updateFeedback();
  }

  #updateFeedback = () => {
    const { form, email, feedback } = this.refs;
    const submitted = form.matches(':target');
    if (!submitted) this.#focusedFeedback = undefined;
    if (submitted && feedback?.getAttribute('role') === 'alert') {
      email.setAttribute('aria-invalid', 'true');
      email.setAttribute('aria-describedby', feedback.id);
    } else {
      email.removeAttribute('aria-invalid');
      email.removeAttribute('aria-describedby');
    }
    // Browsers can suppress autofocus when the URL already has a fragment.
    const active = document.activeElement;
    const leavingFeedback = active?.matches('.contact-form__error, .contact-form__success') &&
      active.closest('.contact-form__form')?.matches(':not(:target)');
    if (
      submitted && feedback && this.#focusedFeedback !== feedback &&
      (active === document.body || active === feedback || leavingFeedback)
    ) {
      feedback.focus();
      if (document.activeElement === feedback) this.#focusedFeedback = feedback;
    }
  };
}

if (!customElements.get('contact-form-component')) {
  customElements.define('contact-form-component', ContactFormComponent);
}
